import { FC } from 'react';
import EditButton from '@components/EditButton';
import ChatCircle from '@components/Icons/ChatCircle';
import FlagBanner from '@components/Icons/FlagBanner';
import DOMPurify from 'isomorphic-dompurify';
import classNames from 'classnames';
import * as format from '@format';
import { ThisWorkflowStep } from '@components/WorkflowCard/types';
import { SendMessageActionData } from '@components/CreateEditSendMessageActionForm/CreateEditSendMessageActionForm';

import classes from './ActionCard.module.scss';

type WorkflowCardProps = {
  action: ThisWorkflowStep;
  actionData: SendMessageActionData;
  onEditClick: () => void;
};

const ActionCard: FC<WorkflowCardProps> = ({ action, actionData, onEditClick }) => (
  <div className={classes.actionContainer}>
    <div className={classes.header}>
      <FlagBanner weight='fill' size='16'/>
      <p className='caption-bold'>Action</p>
    </div>
    <div className={classes.action}>
      <ChatCircle weight='fill' size='32'/>
      <div className={classes.actionInfo}>
        <p className='body-sm-bold'>{format.actionText(action)}</p>
        {!actionData.message && (
          <div className={classNames('caption', classes.currMessage)}>
            {'Edit to add a message'}
          </div>
        )}
        {actionData.message && actionData.message.html && (
          <div
            className={classNames('caption', classes.currMessage)}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(actionData.message.html) }}
          />
        )}
      </div>
      <EditButton label="Edit" onClick={onEditClick}/>
    </div>
  </div>
);

export default ActionCard;